import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { myRewardBackIconSrc } from '../../assets/bazzar';
import { BAZZAR_PATH } from '../../routes/paths';

/** Figma 10040:6903 / 10040:5630 — back row + page title */
const HEADER_TEXT_SHADOW = '0 4px 4px rgba(17, 5, 37, 0.1)';

const backLabelSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.8px',
  color: '#fff',
  textShadow: HEADER_TEXT_SHADOW,
  whiteSpace: 'nowrap',
};

const pageTitleSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 800,
  fontSize: { xs: 16, sm: 22, md: 30 },
  lineHeight: { xs: '28px', sm: '34px', md: '44px' },
  letterSpacing: '2.5px',
  color: '#fff',
  textTransform: 'uppercase',
  textShadow: HEADER_TEXT_SHADOW,
  whiteSpace: 'nowrap',
};

/** Figma 9906:25844 — My Profile page title */
const profilePageTitleSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '32px',
  letterSpacing: '0.8px',
  color: '#7000b9',
  textTransform: 'uppercase',
  textShadow: '0 4px 4px rgba(0, 0, 0, 0.1)',
  whiteSpace: 'nowrap',
};

export default function MyRewardPageHeader({
  title = 'My Redeemed Coupons',
  backLabel = 'Back to Home',
  backTo = BAZZAR_PATH,
  variant = 'default',
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(backTo);
  };

  const isProfile = variant === 'profile';

  const backButton = (
    <Box
      component="button"
      type="button"
      onClick={handleBack}
      aria-label={backLabel}
      sx={{
        position: 'relative',
        width: 30,
        height: 30,
        p: 0,
        border: 0,
        borderRadius: '100px',
        flexShrink: 0,
        cursor: 'pointer',
        background: 'linear-gradient(0deg, #5A04D7 0%, #FF00F2 100%)',
        '&:hover': { opacity: 0.92 },
      }}
    >
      <Box
        component="img"
        src={myRewardBackIconSrc}
        alt=""
        sx={{
          position: 'absolute',
          inset: '16.67%',
          width: '66.66%',
          height: '66.66%',
          display: 'block',
        }}
      />
    </Box>
  );

  if (isProfile) {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 48,
          mb: 2.5,
          mt: { xs: 1.5, md: 2 },
          px: { xs: 0.5, md: 0 },
        }}
      >
        <Box sx={{ position: 'absolute', left: { xs: 4, sm: 0 }, top: '50%', transform: 'translateY(-50%)' }}>
          {backButton}
        </Box>
        <Typography component="h1" sx={profilePageTitleSx}>
          {title}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px',
        mb: { xs: 2.5, md: 3.5 },
        mt: { xs: 2.5, md: 3.5 },
        px: { xs: 1, md: 0 },
        mx:'auto',
        width: '100%',
        maxWidth: '1120px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
        {backButton}
        <Typography
          component="button"
          type="button"
          onClick={handleBack}
          sx={{
            ...backLabelSx,
            border: 0,
            bgcolor: 'transparent',
            cursor: 'pointer',
            p: 0,
          }}
        >
          {backLabel}
        </Typography>
      </Box>

      <Typography component="h1" sx={pageTitleSx}>
        {title}
      </Typography>
    </Box>
  );
}
